// extracted by mini-css-extract-plugin
export const layout = "image-module--layout--2kyNA";
export const title = "image-module--title--1HRw1";
export const container = "image-module--container--1b9Xf";